export default __webpack_public_path__ + "static/SamsungOneUI-700-03c5bb4bbc59c61b0892f38c0216692e.ttf";